import React, { useState } from "react";
import { Link, useHistory, useLocation } from "react-router-dom";
import { localUser } from "../../../assets/Helpers";
import "./AdminLayout.scss";

const AdminLayout = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const history = useHistory();
  const location = useLocation();
  const user = localUser();

  const handleLogout = () => {
    localStorage.removeItem("BEGROSS_USER");
    localStorage.removeItem("woo-session");
    history.push("/admin/login");
  };

  const menuItems = [
    { path: "/admin", label: "Dashboard", icon: "" },
    { path: "/admin/products", label: "Products", icon: "" },
    { path: "/admin/categories", label: "Categories", icon: "" },
    { path: "/admin/brands", label: "Brands", icon: "" },
    { path: "/admin/theme-options", label: "Theme Options", icon: "" },
    { path: "/admin/orders", label: "Orders", icon: "" },
    { path: "/admin/customers", label: "Customers", icon: "" },
    { path: "/admin/users", label: "Users", icon: "" },
  ];

  return (
    <div className="admin-layout">
      {/* Sidebar */}
      <div className={`admin-sidebar ${sidebarOpen ? "open" : "closed"}`}>
        <div className="admin-sidebar-header">
          <h2>Begmart Admin</h2>
          <button
            className="toggle-sidebar"
            onClick={() => setSidebarOpen(!sidebarOpen)}
          >
            {sidebarOpen ? "◀" : "▶"}
          </button>
        </div>

        <nav className="admin-nav">
          {menuItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className={`admin-nav-item ${
                location.pathname === item.path ? "active" : ""
              }`}
            >
              {item.icon && <span className="nav-icon">{item.icon}</span>}
              {sidebarOpen && <span className="nav-label">{item.label}</span>}
            </Link>
          ))}
        </nav>

        <div className="admin-sidebar-footer">
          {sidebarOpen && (
            <div className="admin-user-info">
              <p>{user?.firstName || "Admin"}</p>
              <button onClick={handleLogout} className="logout-btn">
                Logout
              </button>
            </div>
          )}
        </div>
      </div>

      {/* Main Content */}
      <div className="admin-content">
        <div className="admin-header">
          <h1>
            {menuItems.find((item) => item.path === location.pathname)?.label ||
              "Admin Panel"}
          </h1>
        </div>
        <div className="admin-main">{children}</div>
      </div>
    </div>
  );
};

export default AdminLayout;



